import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import './Navigation.css';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`navigation-header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navigation-container">
        <a href="#hero" className="navigation-logo" onClick={(e) => {
          e.preventDefault();
          scrollToSection('hero');
        }}>
          The Heaven Town
        </a>

        <ul className={`navigation-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <li>
            <a href="#about" className="navigation-link" onClick={(e) => {
              e.preventDefault();
              scrollToSection('about');
            }}>
              About
            </a>
          </li>
          <li>
            <a href="#rooms" className="navigation-link" onClick={(e) => {
              e.preventDefault();
              scrollToSection('rooms');
            }}>
              Rooms
            </a>
          </li>
          <li>
            <a href="#nearby-places" className="navigation-link" onClick={(e) => {
              e.preventDefault();
              scrollToSection('nearby-places');
            }}>
              Nearby
            </a>
          </li>
          <li>
            <a href="#gallery" className="navigation-link" onClick={(e) => {
              e.preventDefault();
              scrollToSection('gallery');
            }}>
              Gallery
            </a>
          </li>
          <li>
            <a href="#location" className="navigation-link" onClick={(e) => {
              e.preventDefault();
              scrollToSection('location');
            }}>
              Location
            </a>
          </li>
        </ul>

        <div className="navigation-utilities">
          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
